import React, { Component } from 'react';
import { connect } from 'react-redux';


class Register extends Component {
    render() {
        return (
            <div>
                Register
            </div>

        );
    }
}

const mapStateToProps = () => {
    return {
    };
};

export default connect(mapStateToProps)(Register);



// WEBPACK FOOTER //
// ./src/components/Register/Register.js